import { AutocompleteProps, AutocompleteRenderInputParams, SxProps, TextField, Theme } from '@mui/material';

export interface IIdSelectorProps extends Omit<
  AutocompleteProps<number, boolean | undefined, boolean | undefined, boolean | undefined>,
  | 'options'
  | 'getOptionLabel'
  | 'renderOption'
  | 'renderTags'
  | 'filterOptions'
  | 'groupBy'
  | 'isOptionEqualToValue'
  | 'defaultValue'
  | 'renderInput'
  | 'onChange'
  | 'onHighlightChange'
  | 'getOptionKey'
  | 'slotProps'
> {
  value: number | number[] | null;
  onChange: (newValue: number | number[] | null) => void;
  getOptionDisabled?: (id: number) => boolean;
}

export const renderInput = (params: AutocompleteRenderInputParams) => {
  return <TextField {...params} sx={{ margin: 0 }} />;
};

export const popperSx = { fontSize: '0.825rem' };

/**
 * Option rows sized like the app's Select menus, whose MenuItems the theme makes dense
 * (body2, 32px). Goes on the listbox slot, and only there: a font size on the popper
 * never reaches the rows because Autocomplete's paper re-applies body1 on top of it,
 * and a rule on the paper loses `min-height` and padding to the listbox's own option
 * rule, which is inserted later at the same specificity.
 */
export const denseOptionsListboxSx: SxProps<Theme> = (theme) => ({
  '& .MuiAutocomplete-option': {
    ...theme.typography.body2,
    minHeight: 32,
    paddingTop: '4px',
    paddingBottom: '4px',
  },
});
